/**
 * This is the-header-actions script.js file
 */

import LogoutMixin from '@/mixins/logout';
import DispatchersMixin from '@/mixins/dispatchers';
import { generateTabPayload } from '@/use/menu.space';
import { localStorageUser } from '@/use/localstorage.space';

export default {
    name: 'the-header-actions',

    mixins: [LogoutMixin, DispatchersMixin],

    data() {
        return {
            downloads: []
        };
    },

    methods: {
        downloadFile(data, section, format) {
            const fileType = format === 'CSV' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            const blob = new Blob([data], { type: fileType });
            const link = document.createElement('a');
            const urlCreator = window.URL || window.webkitURL;
            link.href = urlCreator.createObjectURL(blob);
            link.download = `${section}.${format}`;
            link.click();
        },
        removeFromList(index) {
            this.downloads.splice(index, 1);
        },
        /**
         * @override
         */
        goToIssues(type) {
            const section = {
                name: 'Casos',
                active: false,
                icon: 'fal fa-exclamation-square',
                route: {
                    name: 'issues'
                }
            };
            let condition = '';
            switch (type) {
                case 'EXPIRED':
                    condition = 'lte';
                    break;
                default:
                    condition = 'gte';
                    break;
            }
            const { user, group } = localStorageUser();
            const filters = [
                {
                    field: 'resolved_on',
                    condition: 'null'
                }
            ];
            if (type === 'EXPIRED') {
                filters.push({
                    field: 'expires_on',
                    condition,
                    conditionValue: this.$moment(new Date(), 'YYYY-MM-DD HH24:MM')
                });
            }
            if (type === 'EXPIRED') {
                filters.push({
                    field: 'uuid_group_assigned',
                    condition: 'or',
                    conditionValue: true
                });
            }
            if (type !== 'PENDING') {
                filters.push({
                    field: 'uuid_group_assigned',
                    condition: 'eq',
                    conditionValue: group.uuid
                });
            } else {
                filters.push({
                    field: 'expires_on',
                    condition,
                    conditionValue: this.$moment(new Date(), 'YYYY-MM-DD HH24:MM')
                });
                filters.push({
                    field: 'status',
                    condition: 'ne',
                    conditionValue: 'RESOLVED'
                });
            }
            if (type === 'UNASSIGNED') {
                filters.push({
                    field: 'uuid_user_assigned',
                    condition: type === 'UNASSIGNED' ? 'null' : 'eq'
                });
            } else {
                filters.push({
                    field: 'uuid_user_assigned',
                    condition: 'eq',
                    conditionValue: user.uuid
                });
            }
            try {
                localStorage.setItem('filt_issu', btoa(unescape(encodeURIComponent(JSON.stringify(filters)))));
                const item = generateTabPayload(section.name, section.route.name);
                this.$root.$emit('update-issue-list', true);
                if (this.$route.name !== section.route.name) {
                    this.setMenuTab(item);
                }
            } catch (error) {
                this.$toast.error(error);
            }
        }
    },

    computed: {
        getUserInitials: {
            /**
             * Gets User Initials
             * @return {String} User initials
             */
            get() {
                const { user } = localStorageUser();
                const abbr = `${user.given_name.substring(0, 1)}${user.family_name_1.substring(0, 1)}`;
                return abbr;
            }
        },
        photo: {
            /**
             * Get users photo
             * @return {String} User photo url
             */
            get() {
                const { user } = localStorageUser();
                return user.photo;
            }
        },
        /**
         * @override
         */
        issues() {
            return this.$store.getters['meStore/issues'];
        },
        /**
         * @override
         */
        totalIssues() {
            const issues = this.$store.getters['meStore/issues'];
            return issues.expired + issues.pending + issues.unassigned;
        }
    },
    mounted() {
        this.$root.$on('addDownloadToList', item => {
            this.downloads.push(item);
        });
    },
    beforeDestroy() {
        this.$root.$off('addDownloadToList');
    }
};
